interface FindParentsParentParams {
  parentPath: (string | Record<string, any>)[]
  document: any
  level?: number
}

export const findParentsParent = ({
  parentPath,
  document,
  level = 1,
}: FindParentsParentParams): any => {
  if (level > parentPath.length) throw new Error('Level is too high')

  const obj = parentPath
    .slice(0, parentPath.length - level)
    .reduce((doc, path) => {
      if (typeof path === 'object' && path !== null) {
        const entries = Object.entries(path)
        const t = entries.length > 0 ? entries[0] : null
        if (!t) return doc
        const [property, value] = t
        return doc.find((d: any) => d[property] === value)
      } else {
        return doc[path]
      }
    }, document)

  console.log('ParentsParents')
  return obj
}